export const FallbackComponent = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        width: "100vw",
        backgroundColor: "#FEF2F2", // red.50
        color: "#1F2937", // gray.800
        fontFamily: "system-ui, -apple-system, sans-serif",
        padding: "2rem",
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          padding: "2.5rem",
          borderRadius: "1rem",
          boxShadow:
            "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
          maxWidth: "28rem",
          width: "100%",
          textAlign: "center",
        }}
      >
        <h2
          style={{
            fontSize: "1.5rem",
            fontWeight: "700",
            marginBottom: "1rem",
            color: "#DC2626", // red.600
          }}
        >
          Something went wrong
        </h2>
        <p
          style={{
            color: "#4B5563",
            marginBottom: "1.5rem",
            lineHeight: "1.5",
          }}
        >
          We encountered an unexpected error. Please try refreshing the page.
        </p>
        <button
          onClick={() => window.location.reload()}
          style={{
            backgroundColor: "#DC2626",
            color: "white",
            padding: "0.75rem 1.5rem",
            borderRadius: "0.5rem",
            fontWeight: "600",
            border: "none",
            cursor: "pointer",
            fontSize: "1rem",
            transition: "background-color 0.2s",
          }}
          onMouseOver={(e) =>
            (e.currentTarget.style.backgroundColor = "#B91C1C")
          }
          onMouseOut={(e) =>
            (e.currentTarget.style.backgroundColor = "#DC2626")
          }
        >
          Refresh Page
        </button>
      </div>
    </div>
  );
};
